import { useEffect, useState } from 'react';

/**
 * Returns a delayed version of the provided value that updates after the specified delay.
 */
export function useDelayedValue<T>(value: T, delay = 250) {
  const [delayedValue, setDelayedValue] = useState<T>(value);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDelayedValue(value);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [value, delay]);
  return delayedValue;
}
